<div class="row">
    <div class="col-md-3">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Onboarded Distributor</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 success">check_circle</span></span></p>
                <h4 class="my-0">{{onboardedDistributor}}
                </h4>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Active Distributor</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 success">check_circle</span></span></p>
                <h4 class="my-0">{{activeDistributor}}
                </h4>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Blocked Distributor</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 danger">block</span></span></p>
                <h4 class="my-0">{{blockedDistributor}}
                </h4>
            </div>
        </div>
    </div>
    <!-- <div class="col-md-3">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <p><span>Registered Customers</span><span class="dash_icon_img"><span
                            class="material-symbols-outlined d1 success">check_circle</span></span></p>
                <h4 class="my-0">{{totalCustomers}}
                </h4>
            </div>
        </div>
    </div> -->
</div>
<div class="row">
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 mt-2">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <h5>Top 5 Performing Distributor</h5>
                <p>Ranking according to date range selected</p>
            </div>
            <div class="dashboard_block_body">
                <div class="no-data-wrapper d-flex" *ngIf="graphdataDistributor.length == 0">
                    <div class="w-100 p-2 text-center border-top no-data-div">No Data available</div>
                </div>
                <ng-container *ngIf="graphdataDistributor.length > 0">
                    <app-table-view [visibleColumnData]="visibleColumnDataDistributor"
                        [visibleColumnsId]="visibleColumnsIdDistributor" [graphdata]="graphdataDistributor"
                        [graphHeader]="graphHeaderDistributor" title="" tableBackground="var(--grey3)" buttonTitle=""
                        [showIconButtonEnd]="false" [showPaginator]="false" [canCreate]="false" [canView]="false"
                        [canDelete]="false" [canEdit]="false" [showFilters]="false" [showPaginator]="false"
                        className="rounded-top-0"></app-table-view>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 mt-2">
        <div class="dashboard_block">
            <div class="dashboard_block_header">
                <h5>Recently Added Distributor</h5>
                <p>Data according date range selected</p>
            </div>
            <div class="dashboard_block_body">
                <div class="no-data-wrapper" [ngClass]="{'d-flex':topRecentDistributor.length == 0}">
                    <div class="w-100 p-2 text-center border-top no-data-div" *ngIf="topRecentDistributor.length == 0">No
                        Data available</div>
                    <table class="table mb-0" *ngIf="topRecentDistributor.length > 0">
                        <tbody>
                            <tr *ngFor="let item of topRecentDistributor">
                                <td class="py-1 align-middle text-center w-50px"><img [src]="item.imgUrl"
                                        class="h-50px" /></td>
                                <td class="text-grey2 py-1 align-middle">{{item.name}}<span
                                        class="text-grey3 d-block">ID: {{item.id}}</span></td>
                                <td class="text-right py-1 align-middle text-center w-32px"><a
                                        [href]="item.navigationUrl"><img
                                            src="../../../../assets/images/dashboard_icons/chevron_right.png" /></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>